document.addEventListener('click', (event) => {
	const link = event.target.closest('.rex-header__nav a[href^="#"]');

	if (!link) {
		return;
	}

	const anchorId = decodeURIComponent(link.hash.slice(1));
	const target = document.getElementById(anchorId);

	if (!target) {
		return;
	}

	event.preventDefault();
	target.scrollIntoView({
		behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
		block: 'start',
	});

	history.pushState(null, '', link.hash);
});
